import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// App
import App from './components/App';

// Firebase service worker
//import registerServiceWorker from './registerServiceWorker';

// Store
import configureStore from './store/configureStore';

// Styles
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../scss/style.scss'
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss'

export const store = configureStore();

ReactDOM.render((
  <Provider store={store}>
	<App/>
  </Provider>
), document.getElementById('root'));
//registerServiceWorker();

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('../firebase-messaging-sw.js')
  .then(function(registration) {
    console.log('Registration successful, scope is:', registration.scope);
  }).catch(function(err) {
    console.log('Service worker registration failed, error:', err);
  });
}



// WEBPACK FOOTER //
// ./src/index.js